
export function getLocaleFromCookies(): string {
  if (typeof document === 'undefined') return 'id'
  
  const cookies = document.cookie.split(';')
  const localeCookie = cookies.find(cookie => cookie.trim().startsWith('locale='))
  return localeCookie ? localeCookie.split('=')[1] : 'id'
}